<div class="dad-forms-tab">
  <div *ngIf="success" class="portal-alert portal-alert--success">
    <i aria-hidden="true" class="fa fa-check-circle"></i>
    {{ successMessage }}
    <button (click)="success = false" aria-label="Close" class="portal-alert-close" type="button">&times;</button>
  </div>

  <p-panel [toggleable]="true">
    <ng-template pTemplate="header">
      <div class="filter-card-header">
        <span class="filter-icon"><i class="fa fa-search"></i></span>
        <span class="filter-card-title">Filter</span>
      </div>
    </ng-template>
    <div class="filter-fields">
      <div class="filter-field filter-field--search">
        <p-floatLabel>
          <input [(ngModel)]="dadSearchCriteria.companyOrBillingAccount" (ngModelChange)="setFilteredDadsList()"
                 id="companyOrBillingAccount" name="companyOrBillingAccount" pInputText type="text">
          <label for="companyOrBillingAccount">Company or Billing account</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--month">
        <p-floatLabel>
          <p-calendar [(ngModel)]="dateFilterFrom" (ngModelChange)="resetDadsWithDate()" appendTo="body" dateFormat="mm/yy"
                      inputId="usageMonthFrom" panelStyleClass="portal-datepicker" view="month"></p-calendar>
          <label for="usageMonthFrom">Usage month From</label>
        </p-floatLabel>
      </div>
      <div class="filter-field filter-field--month">
        <p-floatLabel>
          <p-calendar [(ngModel)]="dateFilterTo" (ngModelChange)="resetDadsWithDate()" appendTo="body" dateFormat="mm/yy"
                      inputId="usageMonthTo" panelStyleClass="portal-datepicker" view="month"></p-calendar>
          <label for="usageMonthTo">Usage month To</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-multiSelect [(ngModel)]="dadSearchCriteria.exchanges" (ngModelChange)="setFilteredDadsList()" [options]="exchangeNamesList"
                         appendTo="body" inputId="dadExchanges" panelStyleClass="portal-overlay"></p-multiSelect>
          <label for="dadExchanges">Exchange</label>
        </p-floatLabel>
      </div>
      <div class="filter-field">
        <p-floatLabel>
          <p-multiSelect [(ngModel)]="dadSearchCriteria.status" (ngModelChange)="setFilteredDadsList()" [options]="statusOptions"
                         appendTo="body" inputId="dadStatus" panelStyleClass="portal-overlay"></p-multiSelect>
          <label for="dadStatus">Form status</label>
        </p-floatLabel>
      </div>
      <div class="filter-actions">
        <button (click)="resetTable()" class="secondary-btn" type="button">
          <i aria-hidden="true" class="fa fa-refresh"></i>
          Reset
        </button>
      </div>
    </div>
  </p-panel>

  <div *ngIf="selectedDads.length > 0" class="dad-forms-bulk">
    <span class="dad-forms-bulk-count">{{ selectedDads.length }} selected</span>
    <button (click)="exportDadFormPdfs()" class="primary-btn" type="button">
      <i aria-hidden="true" class="fa fa-download"></i>
      Export as PDF
    </button>
    <button (click)="selectedDads = []" class="action-link" type="button">Clear selection</button>
  </div>

  <p-table #dataTable (sortFunction)="tableService.customSort($event)" [(selection)]="selectedDads" [columns]="cols" [customSort]="true"
           [paginator]="true" [rows]="20" [value]="filteredDads">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngFor="let col of cols"
            [pSortableColumnDisabled]="!col.sortable"
            [pSortableColumn]="col.field"
            [width]="col.width">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template let-dad pTemplate="body">
      <tr>
        <td>
          <p-tableCheckbox [value]="dad"></p-tableCheckbox>
        </td>
        <td class="when-cell">{{ dad?.createdAt | date: 'yyyy-MM-dd':'+1000' }}</td>
        <td class="record-cell">{{ dad?.companyName }}</td>
        <td>{{ dad?.billingAccountName }}</td>
        <td>{{ dad?.exchangeNameInTitle }}</td>
        <td>
          <span *ngIf="dad?.status" [ngClass]="statusClass(dad.status)" class="status-pill">{{ dad.status }}</span>
        </td>
        <td class="when-cell">{{ dad?.usageMonth | date: 'yyyy-MM-01':'+8000' }}</td>
        <td class="when-cell">{{ dad?.cutoff }}</td>
        <td>{{ dad?.autoReport | autoReport }}</td>
        <td>{{ dad?.carriedForward === true ? 'Yes' : 'No' }}</td>
        <td>{{ dad?.reminderStatus }}</td>
        <td style="min-width: 160px;">
          <div class="action-links">
            <a *ngIf="this.canEditForm(dad)" class="action-link" routerLink="/dad-form/{{dad.uniqid}}">Edit form</a>
            <button (click)="downloadPdf(dad)" class="action-link" type="button">Download PDF</button>
            <a *ngIf="this.canSeeOriginalClientDeclaration(dad)" class="action-link"
               routerLink="/dad-form/{{dad.uniqid}}/original">See original client DAD form</a>
            <ng-container *ngIf="!dad?.isSelfReported && dad?.dadConfig?.canAutoReport">
              <button (click)="alterAutoReport(dad)" *roles="['ROLE_MCKAY']" class="action-link" type="button">
                <ng-container *ngIf="dad.autoReport">Disable auto-report</ng-container>
                <ng-container *ngIf="!dad.autoReport">Enable auto-report</ng-container>
              </button>
            </ng-container>
            <button (click)="editBoxUrl(dad)" *roles="['ROLE_MCKAY']" class="action-link" type="button">
              Edit link to Box
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="cols.length + 1">
          <div *ngIf="loadError" class="empty-state">
            <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
            <div class="empty-state-title">The DAD forms could not be loaded. Please try again later.</div>
          </div>
          <div *ngIf="!loadError" class="empty-state">
            <i aria-hidden="true" class="fa fa-search"></i>
            <div class="empty-state-title">No DAD form found</div>
            <div class="empty-state-subtitle">Try adjusting your search or filters.</div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *roles="['ROLE_MCKAY']">
    <p-dialog [(visible)]="boxUrlDialogVisible" [closeOnEscape]="true" [modal]="true" [style]="{ width: '40rem' }"
              header="Edit Link to box">
      <div class="flex align-items-center gap-3 mb-3">
        <div [ngClass]="{'p-invalid': true}">
          <input pInputText [ngClass]="{'p-invalid': true}"
                 [style]="this.boxUrlError ? 'color: red; border-color: red': ''"
                 id="boxUrl" autocomplete="off" style="width: 100%;" [(ngModel)]="currentBoxUrl" (ngModelChange)="removeError()"/>
          <small class="p-error" *ngIf="this.boxUrlError">URL must start with "https://mckay-brothers.app.box.com"</small>
        </div>
      </div>
      <div class="flex justify-content-end gap-2 pull-right">
        <p-button class="mr-2" label="Save" (onClick)="saveBoxUrl()"/>
        <p-button label="Cancel" severity="info" (onClick)="closeBoxUrl()"/>
      </div>
    </p-dialog>
  </div>
</div>
